import { apiFetchFile } from "../../toolympus/api/files";

// Dictionary of common file extensions that modern browsers can natively display
const VIEWABLE_MIME_TYPES: Record<string, string> = {
    'pdf': 'application/pdf',
    'txt': 'text/plain',
    'png': 'image/png',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'gif': 'image/gif',
    'svg': 'image/svg+xml',
    'webp': 'image/svg+xml', // webp is supported by most modern browsers
    'mp4': 'video/mp4',
    'webm': 'video/webm',
    'mp3': 'audio/mpeg',
    'json': 'application/json'
};

const getExtension = (filename: string): string => {
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
};

export const downloadOrViewFile = (url: string, filename: string) => {
    const ext = getExtension(filename);
    const viewableMimeType = VIEWABLE_MIME_TYPES[ext];
    
    const isViewable = !!viewableMimeType;

    // If it's viewable, we MUST open the tab synchronously before the fetch
    // to prevent the browser's pop-up blocker from intercepting it.
    let newTab: Window | null = null;
    if (isViewable) {
        newTab = window.open('', '_blank');
        if (newTab) {
            newTab.document.title = filename;
            newTab.document.body.innerHTML = "Loading document, please wait...";
        }
    }

    return apiFetchFile(url)
        .then(rawBlob => {
            let finalBlob = rawBlob;

            if (isViewable) {
                // 1. VIEW IN BROWSER
                // Re-create the blob with the exact MIME type so the browser knows how to render it
                finalBlob = new Blob([rawBlob], { type: viewableMimeType });
                const objectUrl = window.URL.createObjectURL(finalBlob);

                if (newTab) {
                    newTab.location.href = objectUrl;
                    newTab.document.title = filename;

                } else {
                    // Fallback if popup was blocked
                    window.open(objectUrl, '_blank');
                }

                // Delay revocation so the new tab has time to load the blob into memory
                setTimeout(() => {
                    window.URL.revokeObjectURL(objectUrl);
                }, 15000); 

            } else {
                // 2. DOWNLOAD FILE (Original behavior)
                const objectUrl = window.URL.createObjectURL(finalBlob);
                
                const anchor = document.createElement("a");
                document.body.appendChild(anchor);
                anchor.style.display = 'none';
                anchor.href = objectUrl;
                anchor.download = filename; // Forces download
                anchor.click();

                // Clean up DOM and memory immediately
                document.body.removeChild(anchor);
                window.URL.revokeObjectURL(objectUrl);
            }
        })
        .catch(err => {
            // Close the empty tab if the network request fails
            if (newTab) newTab.close();
            throw err;
        });
}
